module.exports = __webpack_public_path__ + "media/images/voice05-fdb4bbf124d6275bc5ce6990d2ea85ec.jpg";